import { ReactElement } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../../../types/paginationRequestType';
import { paginated } from '../../api';
import { Institution, InstitutionFilters } from '../../interfaces/type';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PaginationQueryDto<InstitutionFilters>,
  PaginationRequestType<Institution>,
  AxiosResultDefaultError
>();

export function useInstitutionsLoader() {
  return useFetch();
}

export const InstitutionsLoaderConsumer = FetchConsumer;

export default function InstitutionsLoader({ children }: BaseLoaderProps) {
  return (
    <FetchProvider
      request={paginated}
      defaultQuery={{ page: 1, items_per_page: 10 }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading className="mx-auto" />;
          } else if (error) {
            return (
              <div className="w-100 d-flex justify-content-center">
                <DisplayError textBody={error.code} retryAction={refresh} />
              </div>
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
